
import { Component, mixins } from 'nuxt-property-decorator';
import { MultiColumnsBlockModel } from 'fourwaves-shared';
import ContentBlockMixin from '../../ContentBlockMixin';
import MultiColumnsBlockList from './MultiColumnsBlockList.vue';

@Component({
  components: {
    MultiColumnsBlockList,
  },
})
export default class MultiColumnsBlock extends mixins(ContentBlockMixin<MultiColumnsBlockModel>) {}
